import {
  Directive,
  Input,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';
import { IAppState } from '@myStore/app.state';
import { selectProfile } from '@myStore/profile-view/profile-view.selector';

import { select, Store } from '@ngrx/store';
import { PermissionService } from '@services/permission/permission.service';
import { Subject } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';

@Directive({
  selector: '[appCheckPermissions]',
})
export class CheckPermissionsDirective implements OnInit, OnDestroy {
  @Input() appCheckPermissions!: string[];

  private destroy$ = new Subject<boolean>();

  constructor(
    private _store: Store<IAppState>,
    private permissionService: PermissionService,
    private templateRef: TemplateRef<HTMLElement>,
    private viewContainer: ViewContainerRef
  ) {}

  ngOnInit() {
    this._store
      .pipe(select(selectProfile), take(1), takeUntil(this.destroy$))
      .subscribe(profile => {
        if (
          profile &&
          (profile?.is_superuser ||
            this.permissionService.checkPermission(
              profile,
              this.appCheckPermissions
            ))
        ) {
          this.viewContainer.createEmbeddedView(this.templateRef);
        } else {
          this.viewContainer.clear();
        }
      });
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.complete();
  }
}
